module.exports = __webpack_public_path__ + "media/site/images/svg/logos/ceod-logo-73544511f830aa16acdccb15d981f150.svg";